import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import classnames from "classnames";
import "./loader.scss";
export const Loader = memo(({ className, isCentered = false }) => (_jsx("div", { className: classnames(["loader", { "loader--centered": isCentered }, className]), children: _jsxs("div", { className: "loader__list", children: [_jsx("div", { className: "loader__element" }), _jsx("div", { className: "loader__element" }), _jsx("div", { className: "loader__element" })] }) })));
